import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df724db4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row q-col-gutter-lg" }
const _hoisted_2 = { id: "circularProgressContainer" }
const _hoisted_3 = {
  class: "col-xs-8",
  id: "pageTitleContainer"
}
const _hoisted_4 = {
  class: "text-h4 text-weight-bold",
  id: "pageTitle"
}
const _hoisted_5 = {
  key: 0,
  class: "q-py-xs",
  id: "pageDescription"
}
const _hoisted_6 = {
  key: 0,
  id: "pageContent"
}
const _hoisted_7 = {
  id: "groupTitle",
  class: "text-h6"
}
const _hoisted_8 = {
  key: 0,
  id: "textField"
}
const _hoisted_9 = {
  key: 1,
  id: "numericField"
}
const _hoisted_10 = {
  key: 2,
  id: "dateField"
}
const _hoisted_11 = { class: "row items-center justify-end" }
const _hoisted_12 = {
  key: 3,
  id: "radioButtonField"
}
const _hoisted_13 = {
  key: 4,
  id: "selectField"
}
const _hoisted_14 = { class: "selectFieldLabel" }
const _hoisted_15 = {
  key: 5,
  id: "multiselectField"
}
const _hoisted_16 = {
  key: 6,
  id: "checkboxField"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircularProgress = _resolveComponent("CircularProgress")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_option_group = _resolveComponent("q-option-group")!
  const _component_q_field = _resolveComponent("q-field")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CircularProgress)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.title)), 1),
        (_ctx.description)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.description)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_q_separator, {
      class: "q-my-md",
      id: "separator"
    }),
    (_ctx.groups)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
            return (_openBlock(), _createBlock(_component_q_card, {
              flat: "",
              bordered: "",
              key: group,
              id: "groupContainer"
            }, {
              default: _withCtx(() => [
                group
                  ? (_openBlock(), _createBlock(_component_q_card_section, {
                      key: 0,
                      class: "group-heading"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(group)), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_card_section, {
                  id: "visitorDetailsContainer",
                  class: "group-body"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
                      return (_openBlock(), _createBlock(_component_q_form, {
                        ref_for: true,
                        ref: "visitorDetailsForm",
                        class: "details-container",
                        key: field.cdfId,
                        id: "visitorDetailsForm",
                        onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                      }, {
                        default: _withCtx(() => [
                          (field.groupName === group && field.typeId === 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(_component_q_input, {
                                  modelValue: field.originalValue,
                                  "onUpdate:modelValue": ($event: any) => ((field.originalValue) = $event),
                                  label: _ctx.$t(field.displayValue),
                                  "reactive-rules": true,
                                  rules: field.mandatory && !field.readOnly ? [val => !!val || _ctx.$t('portal_requiredMsg')] : undefined,
                                  "stack-label": "",
                                  filled: "",
                                  "hide-bottom-space": "",
                                  id: "visitorDetailsInput",
                                  class: _normalizeClass({ required: field.mandatory }),
                                  disable: field.readOnly
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "rules", "class", "disable"])
                              ]))
                            : _createCommentVNode("", true),
                          (field.groupName === group && field.typeId === 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(_component_q_input, {
                                  modelValue: field.originalValue,
                                  "onUpdate:modelValue": ($event: any) => ((field.originalValue) = $event),
                                  label: _ctx.$t(field.displayValue),
                                  "reactive-rules": true,
                                  rules: field.mandatory && !field.readOnly ? [val => !!val || _ctx.$t('portal_requiredMsg')] : undefined,
                                  type: "number",
                                  "stack-label": "",
                                  filled: "",
                                  "hide-bottom-space": "",
                                  id: "visitorDetailsInput",
                                  class: _normalizeClass({ required: field.mandatory }),
                                  disable: field.readOnly
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "rules", "class", "disable"])
                              ]))
                            : _createCommentVNode("", true),
                          (field.groupName === group && field.typeId === 5)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_component_q_input, {
                                  filled: "",
                                  modelValue: field.originalValue,
                                  "onUpdate:modelValue": ($event: any) => ((field.originalValue) = $event),
                                  "stack-label": "",
                                  label: _ctx.$t(field.displayValue),
                                  disable: field.readOnly,
                                  "reactive-rules": true,
                                  rules: field.mandatory && !field.readOnly ? 
								[_ctx.validateRequiredDate] : !field.readOnly ? [_ctx.validateOptionalDate] : undefined,
                                  "hide-bottom-space": "",
                                  id: "visitorDetailsInput",
                                  class: _normalizeClass({ required: field.mandatory })
                                }, {
                                  append: _withCtx(() => [
                                    (!field.readOnly)
                                      ? (_openBlock(), _createBlock(_component_q_icon, {
                                          key: 0,
                                          name: "event",
                                          class: "cursor-pointer"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_popup_proxy, {
                                              cover: "",
                                              "transition-show": "scale",
                                              "transition-hide": "scale"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_date, {
                                                  type: "date",
                                                  modelValue: field.originalValue,
                                                  "onUpdate:modelValue": ($event: any) => ((field.originalValue) = $event),
                                                  value: field.originalValue,
                                                  minimal: "",
                                                  mask: "DD-MMM-YYYY",
                                                  id: "visitorDetailsInputDate"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_11, [
                                                      _withDirectives(_createVNode(_component_q_btn, {
                                                        label: _ctx.$t('portal_close'),
                                                        color: "primary",
                                                        flat: ""
                                                      }, null, 8, ["label"]), [
                                                        [_directive_close_popup]
                                                      ])
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue", "value"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "label", "disable", "rules", "class"])
                              ]))
                            : _createCommentVNode("", true),
                          (field.groupName === group && field.typeId === 2 && field.subTypeId === 4)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(_component_q_field, {
                                  "stack-label": "",
                                  label: _ctx.$t(field.displayValue),
                                  modelValue: field.originalValue,
                                  "onUpdate:modelValue": ($event: any) => ((field.originalValue) = $event),
                                  filled: "",
                                  "reactive-rules": true,
                                  rules: field.mandatory && !field.readOnly ? [val => !!val || _ctx.$t('portal_requiredMsg')] : undefined,
                                  "hide-bottom-space": "",
                                  id: "visitorDetailsInput",
                                  class: _normalizeClass({ required: field.mandatory }),
                                  disable: field.readOnly
                                }, {
                                  control: _withCtx(() => [
                                    _createVNode(_component_q_option_group, {
                                      options: _ctx.portal.getSelectOptions(field.listOptions),
                                      type: "radio",
                                      modelValue: field.originalValue,
                                      "onUpdate:modelValue": ($event: any) => ((field.originalValue) = $event),
                                      id: "visitorDetailsInputOptionGroup",
                                      disable: field.readOnly
                                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "disable"])
                                  ]),
                                  _: 2
                                }, 1032, ["label", "modelValue", "onUpdate:modelValue", "rules", "class", "disable"])
                              ]))
                            : _createCommentVNode("", true),
                          (field.groupName === group && field.typeId === 2 && field.subTypeId === 5)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t(field.displayValue)), 1),
                                _createVNode(_component_q_select, {
                                  filled: "",
                                  "stack-label": "",
                                  "emit-value": "",
                                  modelValue: field.originalValue,
                                  "onUpdate:modelValue": ($event: any) => ((field.originalValue) = $event),
                                  options: _ctx.portal.getSelectOptions(field.listOptions),
                                  "display-value": field.originalValue ? _ctx.portal._translate(field.originalValue.replace(/ /g, '-').toLowerCase()) : '',
                                  label: _ctx.$t(field.displayValue),
                                  "reactive-rules": true,
                                  rules: field.mandatory && !field.readOnly ? [val => !!val || _ctx.$t('portal_requiredMsg')] : undefined,
                                  "hide-bottom-space": "",
                                  id: "visitorDetailsInput",
                                  class: _normalizeClass({ required: field.mandatory }),
                                  disable: field.readOnly
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "display-value", "label", "rules", "class", "disable"])
                              ]))
                            : _createCommentVNode("", true),
                          (field.groupName === group && field.typeId === 2 && field.subTypeId === 7)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createVNode(_component_q_field, {
                                  "stack-label": "",
                                  label: _ctx.$t(field.displayValue),
                                  modelValue: field.originalValue,
                                  "onUpdate:modelValue": ($event: any) => ((field.originalValue) = $event),
                                  filled: "",
                                  "reactive-rules": true,
                                  rules: field.mandatory && !field.readOnly ? [val => val.length || _ctx.$t('portal_requiredMsg')] : undefined,
                                  "hide-bottom-space": "",
                                  id: "visitorDetailsInput",
                                  class: _normalizeClass({ required: field.mandatory }),
                                  disable: field.readOnly
                                }, {
                                  control: _withCtx(() => [
                                    _createVNode(_component_q_option_group, {
                                      options: _ctx.portal.getSelectOptions(field.listOptions),
                                      type: "checkbox",
                                      modelValue: field.originalValue,
                                      "onUpdate:modelValue": ($event: any) => ((field.originalValue) = $event),
                                      id: "visitorDetailsInputOptionGroup",
                                      disable: field.readOnly
                                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "disable"])
                                  ]),
                                  _: 2
                                }, 1032, ["label", "modelValue", "onUpdate:modelValue", "rules", "class", "disable"])
                              ]))
                            : _createCommentVNode("", true),
                          (field.groupName === group && field.typeId === 6 && field.subTypeId === 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createVNode(_component_q_field, {
                                  filled: "",
                                  "stack-label": "",
                                  id: "visitorDetailsInput",
                                  class: _normalizeClass({ required: field.mandatory }),
                                  disable: field.readOnly
                                }, {
                                  control: _withCtx(() => [
                                    _createVNode(_component_q_checkbox, {
                                      modelValue: field.originalValue,
                                      "onUpdate:modelValue": ($event: any) => ((field.originalValue) = $event),
                                      "true-value": "on",
                                      "false-value": "off",
                                      label: _ctx.$t(field.displayValue),
                                      disable: field.readOnly
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disable"])
                                  ]),
                                  _: 2
                                }, 1032, ["class", "disable"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}